import { t } from 'c-3po';
import React from 'react';

export const CompanyRecommendationMsg = ({ safetyRecommendationUrl }) => {
    return (
        <div>
            {t`Рекомендации по безопасности:`}
            <ul>
                <li>{t`Не сообщайте покупателю личную информацию, кроме номера карты и ФИО;`}</li>
                <li>{t`Обязательно проверяйте зачисление денег на ваш счет;`}</li>
                <li>{t`Выбирайте для встречи людные места, или используйте доставку наложенным платежом.`}</li>
            </ul>
            <a href={safetyRecommendationUrl}>{t`Посмотреть все рекомендации`}</a>
        </div>
    )
};
